<atx-contact-list [contacts]="contacts">
  <ng-template #contentOnTheRight let-contact>
    @if ( !userCalling && contact.connectionStatus ===
    ConnectionStatus.AVAILABLE ) {
    <button
      (click)="initCall(contact)"
      class="btn btn-round btn-light btn-icon p-0 ml-3"
      data-e2e="connect-init-call"
    >
      <fa-icon [icon]="['fas', 'video-arrow-up-right']"></fa-icon>
    </button>
    }
  </ng-template>
</atx-contact-list>
